export default __webpack_public_path__ + "static/media/bushaLogo.c115df72.svg";